import React from "react"

import './PushSending.scss'

import { ArrowLeft } from "react-feather";

import { useHistory, Link as LinkRoute } from "react-router-dom";

import PageHeading from "../../components/commonComponents/pageHeading/pageHeading";

import MobileHeader from "../../components/commonComponents/mobileHeader/MobileHeader";

import Table from "./Table/Table";

const PushSending = () => {

    let history = useHistory();

	const handleBackClick = () => {
		history.goBack()
	}


    return (
        <div className="push-sending">

            <MobileHeader/>

            <div className="push-sending__back-btn">
                <button className="btn w-sm mb-1 btn-secondary" onClick={handleBackClick}>
                    <ArrowLeft size={15} style={{marginRight: 10}}/>Назад
                </button>
            </div>

            <PageHeading mainText={"Рассылка Push-уведомлений"} mutedText={"Управляйте вашими push-уведомлениями"}/>

            <div className="push-sending__card">
                <div className="card">
                    <div className='push-sending__card-content'>

                        <div className="b-b push-sending__controls-wrap">
                            <div>Список push-уведомлений</div>
                            <LinkRoute to="/push-add" className="btn btn-success">Добавить уведомление</LinkRoute>
                        </div>

                        <div className="tab-content p-3">
                            <Table />
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default PushSending